// src/themes.js

export const themes = {
  cyan: {
    primaryColor: "#00BCD4",
    accentColor: "#00838F",
    backgroundColor: "#E0F7FA",
    textColor: "#006064",
    buttonTextColor: "#FFFFFF",
    secondaryColor: "#4DD0E1",
  },
  green: {
    primaryColor: "#4CAF50",
    accentColor: "#388E3C",
    backgroundColor: "#E8F5E9",
    textColor: "#1B5E20",
    buttonTextColor: "#FFFFFF",
    secondaryColor: "#81C784",
  },
  blue: {
    primaryColor: "#105893",
    accentColor: "#0D4676",
    backgroundColor: "#FCFDFD",
    textColor: "#076dbb",
    buttonTextColor: "#FFFFFF",
    secondaryColor: "#B8CEE0",
    primaryColorComplementary: "#105893",
    accentColorComplementary: "#934B10",
    backgroundColorComplementary: "#FCFDFD",
    textColorComplementary: "#081B2B",
    buttonTextColorComplementary: "#FFFFFF",
    secondaryColorComplementary: "#B3CFE6",
  },
  // Mirrors the deployed site-theme.json so first-paint matches the brand
  // (no flash-of-unstyled-theme for cross-origin visitors).
  midnight: {
    themeName: "Midnight",
    primaryColor: "#5693c2",
    accentColor: "#7e9aae",
    backgroundColor: "#10202c",
    textColor: "#fcfcfd",
    buttonTextColor: "#fcfcfc",
    secondaryColor: "#5d6a74",
  },
};
